<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addPipelineAssetLocation()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search..."
          />

          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="custom_table_four_row">
      <form [formGroup]="pipelineassetlocationForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">PipelineAssetLocation Name</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="PipelineAssetLocations">
          <div
            class="td"
            *ngFor="
              let pipelineassetlocations of pipelineassetlocationForm.get('PipelineAssetLocations')['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="PipelineAssetLocationName"
                placeholder="Enter text"
            /></span>


            <button
                class="delete_icon trash"
                (click)="deletePipelineAssetLocation(i, pipelineassetlocations.value)"
              >
                <em class="ti-trash"> </em> </button
            >
          </div>
        </div>

        <div class="submit">
          <button class="submit_button" (click)="onSubmit(pipelineassetlocationForm.value)">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
